// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'open-new-tab';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.688.563h-12a.75.75 0 0 0-.75.75v12c0 .414.335.75.75.75h12a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75z' />
    <path d='M11.063 3.563h2.812a.57.57 0 0 1 .563.562v2.813m-.165-3.21-4.148 4.147M.563 14.063v-1.126m0-2.249a1.125 1.125 0 0 1 1.125-1.126m6.75 4.501v-1.126m0-2.249a1.125 1.125 0 0 0-1.125-1.126m-6.75 6.751a1.125 1.125 0 0 0 1.125 1.125m6.75-1.125a1.125 1.125 0 0 1-1.125 1.125M3.938 9.563h1.124m-1.124 7.875h1.124' />
  </g>
);

export const viewBox = '0 0 18 18';
